import axios from "axios";

// Get API URL from environment variables with fallbacks
const API_URL = process.env.NODE_ENV === 'development'
  ? "http://localhost:5000/v1"
  : "https://api.swiftclear.ca/v1";


const api = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor to include the token in all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is a 401 error for a logging endpoint
    if (
      error.response &&
      error.response.status === 401 &&
      error.config.url.includes('/logs')
    ) {
      // Silently handle 401 errors for logging endpoints
      // Return a resolved promise to prevent the error from propagating
      return Promise.resolve({ data: { silenced: true } });
    }

    // Handle 401 errors for all other endpoints (expired/invalid tokens)
    if (error.response?.status === 401) {
      // Token is expired or invalid
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");

      // Only redirect if we're not already on the auth page
      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth';
      }
    }

    // For all other errors, let them propagate
    return Promise.reject(error);
  }
);

export default api;
